import { NgModule } from '@angular/core';
import { ComposablesModule } from '@legacy/common-ui-common-renderings';
import { CommonUiFormsModule } from '@innogy/common-ui/forms';
import { DefaultComponentModule } from '@innogy/core/modules/components';
import {
  ProgressiveFormComponentsModule,
  ProgressiveFormModule,
} from '@innogy/shared/progressive-form';
import { SitecoreFormsModule } from '@innogy/sitecore-forms';
import { NgrxFormsModule } from 'ngrx-forms';
import {
  CSCaptureDirective,
  CSMaskDirective,
} from '@legacy/utils-contentsquare';

import { ProgressiveFormContainerComponent } from './progressive-form-container';
import {
  ProgressiveAddressFormComponent,
  ProgressivePaymentDetailsFormComponent,
  ProgressivePersonalDetailsFormComponent,
} from './progressive-form-steps';
import { ScProgressiveFormContainerComponent } from './sc-progressive-form-container/sc-progressive-form-container.component';
import { ProgressiveGenericFormComponent } from './progressive-form-steps/progressive-generic-form/progressive-generic-form.component';
import { IsInvalidPipe, IsValidPipe } from '@innogy/utils-deprecated';

const exportedComponents = [
  ScProgressiveFormContainerComponent,
  ProgressiveGenericFormComponent,
  ProgressiveFormContainerComponent,
  ProgressiveAddressFormComponent,
  ProgressivePersonalDetailsFormComponent,
  ProgressivePaymentDetailsFormComponent,
];

/**
 * to be removed after https://jira.essent.nl/jira/browse/FEIT-302 is implemented.
 * @deprecated - this module will be **deleted** as soon as the "CV ketel" buying and selling funnels are migrated away from this module.
 *
 * ALL OTHER IMPLEMENTATIONS WILL BREAK, DO NOT USE THIS MODULE.
 */
@NgModule({
  imports: [
    DefaultComponentModule,
    CommonUiFormsModule,
    NgrxFormsModule,
    ComposablesModule,
    SitecoreFormsModule,
    ProgressiveFormComponentsModule,
    ProgressiveFormModule,
    CSMaskDirective,
    CSCaptureDirective,
    IsValidPipe,
    IsInvalidPipe,
    ...exportedComponents,
  ],
  exports: [...exportedComponents],
})
export class SharedProgressiveFormSitecoreModule {}
